import React from 'react';
import { useSelector } from 'react-redux';
import styles from '../styles/SiteTransferNotice.module.css';

const SiteTransferNotice = () => {
  const user = useSelector((state) => state.user.user);

  const handleTransferClick = () => {
    const userToken = user?.userToken || localStorage.getItem('userToken');
    const targetUrl = userToken
      ? `https://aimonkey.plus?userToken=${userToken}`
      : 'https://aimonkey.plus';
    window.open(targetUrl, '_blank');
  };

  return (
    <div className={styles.page}>
      <div className={styles.bg} />

      <div className={styles.inner}>
        {/* 顶部图标 + 标题 */}
        <div className={styles.hero}>
          <div className={styles.iconWrap}>
            <i className="fas fa-plug"></i>
            <div className={styles.iconBadge}>
              <i className="fas fa-times"></i>
            </div>
          </div>
          <h1 className={styles.title}>当前 GPT 节点已失效</h1>
          <div className={styles.reassure}>
            <i className="fas fa-shield-alt"></i>
            <span>不是您的账号有问题 — 只是这个节点不可用了，换一个即可</span>
          </div>
        </div>

        {/* 三步操作 */}
        <div className={styles.steps}>
          <div className={styles.step}>
            <div className={styles.stepNum}>1</div>
            <div className={styles.stepIcon}><i className="fas fa-arrow-left"></i></div>
            <div className={styles.stepText}>
              <strong>返回 GPT 车队</strong>
              <span>点击下方按钮回到节点列表</span>
            </div>
          </div>

          <div className={styles.stepArrow}><i className="fas fa-chevron-right"></i></div>

          <div className={styles.step}>
            <div className={styles.stepNum}>2</div>
            <div className={styles.stepIcon}><i className="fas fa-server"></i></div>
            <div className={styles.stepText}>
              <strong>选择一个新节点</strong>
              <span>任意选择一个状态正常的节点</span>
            </div>
          </div>

          <div className={styles.stepArrow}><i className="fas fa-chevron-right"></i></div>

          <div className={styles.step}>
            <div className={styles.stepNum}>3</div>
            <div className={styles.stepIcon}><i className="fas fa-comment-dots"></i></div>
            <div className={styles.stepText}>
              <strong>开启新的对话</strong>
              <span>点击「新的对话」即可正常使用</span>
            </div>
          </div>
        </div>

        {/* 按钮 */}
        <button className={styles.btn} onClick={handleTransferClick}>
          <i className="fas fa-arrow-left"></i>
          返回 GPT 车队，重新选择节点
        </button>

        <p className={styles.tip}>
          <i className="fas fa-info-circle"></i>
          换节点后记得开启新的对话，旧对话不会自动迁移
        </p>
      </div>
    </div>
  );
};

export default SiteTransferNotice;
